import React__default from 'react';
import { SvgIcon48 } from '../svgIcon48.js';

const RightArrowIcon = ({ fill = '#828282' }) => {
    return (React__default.createElement(SvgIcon48, { viewbox: "0 0 48 48", title: "leftArrowIcon" },
        React__default.createElement("g", { id: "rigthArrowIcon", fill: fill },
            React__default.createElement("path", { d: "M33.59,21.16,16,3.53a1.63,1.63,0,0,0-2-.3,1.54,1.54,0,0,0-.26,2.39L31,22.93a1.5,1.5,0,0,1,0,2.12L13.78,42.28a1.63,1.63,0,0,0-.3,2,1.54,1.54,0,0,0,2.39.26L33.59,26.82A4,4,0,0,0,33.59,21.16Z" }))));
};

export { RightArrowIcon };
